import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFParticularHoldingUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.mfParticularHolding(req);
    }
}
export default MFParticularHoldingUseCase;
